import { LoginOutlined } from "@ant-design/icons";
import { yupResolver } from "@hookform/resolvers/yup";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { Button, Col, Form, Row } from "antd";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { CustomInput } from "../../../../../shared/formFields/CustomInput";
import { useStartApplicationMutation } from "../../../../../store/baseApi";
import { continueApplicationSchema } from "../formSchema";

const ContinueApplicationForm = () => {
  const navigate = useNavigate();
  const [startApplication, { status, data, isLoading }] =
    useStartApplicationMutation();
  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: {
      id: "",
    },
    resolver: yupResolver(continueApplicationSchema),
  });

  useEffect(() => {
    if (status === QueryStatus.fulfilled) {
      if (data.success === true) {
        navigate(`/all-forms/private-aviation/${data.content.id}`);
      }
    }
  }, [status, data, navigate]);

  const onFinish = (values) => {
    trigger();
    startApplication({ id: values.id, isNew: false });
  };

  return (
    <Form
      name="get_started"
      autoComplete="off"
      layout="vertical"
      labelWrap
      onFinish={() => handleSubmit(onFinish)()}
    >
      <Row>
        <Col span={24}>
          <CustomInput
            formItem={{ required: true, label: "Application Number" }}
            disabled={isLoading}
            control={control}
            name="id"
            placeholder="Enter your application number"
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Button
            loading={isLoading}
            htmlType="submit"
            type="primary"
            disabled={Object.keys(errors ?? {}).length > 0}
          >
            {!isLoading && <LoginOutlined />} Continue application
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContinueApplicationForm;
